function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreditCardIcons = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 0,
  height: 0,
  className: "hidden"
}, props));
export { SvgCreditCardIcons as ReactComponent };
export default __webpack_public_path__ + "assets/media/credit-card-icons.1f452ec4a877efcb843ff76421bb2a1f.svg";